var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrnament(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1907 294 l-99 -95 99 -94 98 -94 95 95 95 94 -95 94 -95 95 -98 -95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 259 l-31 -31 -567 -9 c-313 -5 -570 -11 -573 -14 -3 -3 -3 -7 0 -10 2 -3 260 -9 573 -14 l568 -10 34 -33 33 -32 47 47 47 47 -44 45 c-24 25 -47 45 -50 45 -3 0 -19 -14 -37 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 245 l-44 -45 45 -45 45 -45 44 45 44 45 -45 45 -45 45 -44 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 245 l-44 -45 45 -45 45 -45 44 45 44 45 -45 45 -45 45 -44 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 245 l-44 -45 44 -45 44 -45 32 31 32 31 568 9 c312 5 569 11 572 14 3 3 3 7 0 10 -2 3 -260 9 -573 14 l-568 10 -31 30 -32 31 -44 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 216 c-12 -31 0 -51 30 -51 36 0 56 26 37 49 -17 20 -60 21 -67 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704 216 c-12 -31 0 -51 30 -51 36 0 56 26 37 49 -17 20 -60 21 -67 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224 216 c-12 -31 0 -51 30 -51 36 0 56 26 37 49 -17 20 -60 21 -67 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2544 216 c-12 -31 0 -51 30 -51 36 0 56 26 37 49 -17 20 -60 21 -67 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnament);
export default __webpack_public_path__ + "static/media/ornament.da9933521be742f679bb52fdea5da578.svg";
export { ForwardRef as ReactComponent };